import {useQuery} from "@tanstack/react-query";
import {AccountSearchInterface} from "../../correspondent/list/interface/searchInterface";
import {readContactListApi} from "../../../../api/correspondent/contractApi";

type Props = {
    searchOption: AccountSearchInterface & { accountId: string };
};

export const useReadContactList = ({searchOption}: Props) => {
    const {data} = useQuery({
        queryKey: ["readContactList", searchOption],
        queryFn: async () => await readContactListApi({...searchOption}),
        select: (res) => res?.result,
        // staleTime: 10000 * 6,
    });

    return {data};
};
